import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Injector,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { LazySliceService } from '../../../services/lazy-slice.service';
import { AnySlice, LazyLoadedComponent, LazyLoadedComponentType } from './lasy-slice-types';

@Component({
  selector: 'app-lazy-slice',
  templateUrl: './lazy-slice.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazySliceComponent implements OnInit {
  private injector = inject(Injector);
  lazySliceService = inject(LazySliceService);
  private cdr = inject(ChangeDetectorRef);
  @Input() componentType!: string;
  @Input() slice: AnySlice;
  @ViewChild('component', { read: ViewContainerRef }) component!: ViewContainerRef;
  componentInstance!: LazyLoadedComponent;

  async ngOnInit() {
    this.componentInstance = this.createComponent(await this.lazySliceService.loadSliceComponent(this.componentType));
    this.cdr.markForCheck();
  }

  private createComponent(component: LazyLoadedComponentType) {
    this.component.clear();
    const { instance } = this.component.createComponent<LazyLoadedComponent>(component, {
      injector: this.injector,
    });
    instance.slice = this.slice;
    return instance;
  }
}
